import {
  validateProNumberDefault,
  getProNumberDefault,
} from "./validationDefault";
import { validateProNumberSaia, getProNumberSaia } from "./validationSAIA";
import { CUSTOMER_CONFIG } from "../../common/constants";
import { withAppConfig } from "../../../../../../../appConfigContext";
import { withFeatureFlags } from "../../../../../../../userProfile/featureFlagsContext";
import appConstants from "../../../../../../../appConstants";
import { compose } from "recompose";

const getProValidaitonFunctions = (proNumberConfig, enableCheckDigit) => {
  if (proNumberConfig === CUSTOMER_CONFIG.SAIA) {
    return {
      getProNumber: getProNumberSaia(enableCheckDigit),
      validateProNumber: validateProNumberSaia(enableCheckDigit),
    };
  }
  return {
    getProNumber: getProNumberDefault(enableCheckDigit),
    validateProNumber: validateProNumberDefault(enableCheckDigit),
  };
};

export function withProValidationHOC(Component) {
  const UpdatedComponent = (props) => {
    const enableCheckDigit = props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableCheckDigit,
    );
    const proValidation = getProValidaitonFunctions(
      props.configJSON?.proValidation,
      enableCheckDigit,
    );
    return <Component {...props} proValidation={proValidation} />;
  };
  return compose(withFeatureFlags, withAppConfig)(UpdatedComponent);
}